/* eslint-disable class-methods-use-this */
import Resource from '@/services/resources/common';

export default class CommunityPartnerResource extends Resource {
  constructor(entrypoint = '/community_partners', alias = 'CommunityPartner') {
    super(entrypoint, alias);
  }
}
